import React, { useRef } from 'react';
import icSearch1 from 'Assets/img/sidebar/ic_search.png';
import icSearch2 from 'Assets/img/sidebar/ic_search@2x.png';
import icSearch3 from 'Assets/img/sidebar/ic_search@3x.png';
import icDelete1 from 'Assets/img/sidebar/ic_delete.png';
import icDelete2 from 'Assets/img/sidebar/ic_delete@2x.png';
import icDelete3 from 'Assets/img/sidebar/ic_delete@3x.png';

import { getImageSet } from 'Util/DataUtils';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

const icSearch = getImageSet([icSearch1, icSearch2, icSearch3]);
const icDelete = getImageSet([icDelete1, icDelete2, icDelete3]);

const SearchInput = ({ text, onChangeText }) => {
  const { locale } = useSelector(state => state.settings.locale);
  const { formatMessage } = useIntl();
  const inputRef = useRef(null);
  return (
    <div className={`sidebar-search-input ${locale === 'vi' && 'vi'}`}>
      <img
        {...icSearch}
        alt="search"
        onClick={() => {
          inputRef.current.focus();
        }}
      />
      <input ref={inputRef} type="text" placeholder={formatMessage({ id: 'sidebar.field.input.placeholder' })} value={text} onChange={onChangeText} />
      {text && <img {...icDelete} alt="delete" onClick={() => onChangeText({ target: { value: '' } })} className="cursor-pointer" data-field-toggle="true" />}
    </div>
  );
};

export default SearchInput;
